export const safelyGetItem = (key: string) => {
  try {
    return JSON.parse(localStorage.getItem(key) || 'null');
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (_) {
    return null;
  }
};

export const safelySetItem = (key: string, value: unknown) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (_) {
    return null;
  }
};
